import { render, staticRenderFns } from "./UserType.vue?vue&type=template&id=afa9c4b4&scoped=true"
import script from "./UserType.vue?vue&type=script&lang=js"
export * from "./UserType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa9c4b4",
  null
  
)

export default component.exports